import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

import type {AppPayload} from '../types/app-payload'

type SemanticSearchFeaturePreview = {
  isAvailable: boolean
  isEnabled: boolean
  isStaff: boolean
}

const useIssuesIndexSemanticSearchToggleFeaturePreview: () => SemanticSearchFeaturePreview = () => {
  const {semantic_search_enrolled, scoped_repository, current_user} = useAppPayload<AppPayload>()
  const isAvailable = isFeatureEnabled('issues_index_semantic_search') && !!scoped_repository

  const isEnabled = semantic_search_enrolled ?? false
  const isStaff = current_user?.is_staff ?? false

  return {isAvailable, isEnabled, isStaff}
}

export {useIssuesIndexSemanticSearchToggleFeaturePreview}
export type {SemanticSearchFeaturePreview}
